import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './ach300Hmi.css';

// ATH600, DHC600, L70 — the lines counted by a Raspberry Pi, not read from a PLC.
//
// There is no PLC on these: a Pi watches the meter wheel and publishes five
// values. That is the whole of what exists, and this shows all five rather than
// padding the screen out to look like the extruder pages. A panel that invents
// rows is how the old ACH300 page ended up binding thirty-five tag names that
// had never existed.
//
// Before this, `l70` rendered the literal text "L70Hmi", `dhc600` rendered
// NOTHING — the modal tested for `dhc800`, a machine that is not in the
// catalogue — and `ath600` had no branch at all.
//
// Shares the ACH300 stylesheet on purpose: one instrument vocabulary across the
// factory means an operator moving between lines is not relearning the screen.

const num = (v) =>
  v === null || v === undefined || v === '' || Number.isNaN(Number(v)) ? null : Number(v);

const fmt = (v, d = 1) => {
  const n = num(v);
  return n === null ? '—' : n.toFixed(d);
};

// Space-grouped: a lifetime total runs to eight figures, and "33975573" is not a
// number anybody reads.
const grp = (v, d = 0) => {
  const n = num(v);
  if (n === null) return '—';
  const [i, f] = n.toFixed(d).split('.');
  return i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (f ? `.${f}` : '');
};

const MeterLineHmi = ({ machineLive = {}, machineId = '' }) => {
  const live = machineLive;
  // `=== 0`, not truthiness: a stopped line reads exactly 0 and must show as
  // stopped rather than as a missing value.
  const speed = num(live.LINE_SPEED);
  // Present in the live DB0 state but NOT written to Influx, so the binding
  // audit reports it missing. It is real — just not historised. Do not "fix"
  // it by removing it.
  const running = live.LINE_START_RELAY === true;

  return (
    <div className="ach-hmi">
      <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
        <span className="ach-label" style={{ margin: 0 }}>
          {machineId.toUpperCase() || 'LINIE'}
        </span>
        <span className={`ach-lamp ${running ? 'on' : ''}`}>
          {running ? 'Pornită' : 'Oprită'}
        </span>
        {live.STATUS ? (
          <span className="ach-lamp" style={{ opacity: 0.85 }}>{live.STATUS}</span>
        ) : null}
        {live.SHIFT ? (
          <span className="ach-label" style={{ margin: 0 }}>Schimb {live.SHIFT}</span>
        ) : null}
      </div>

      <Row className="g-3 mb-3">
        <Col md={6}>
          <div className="ach-bay">
            <div className="ach-label">Viteză linie</div>
            <div className={`ach-value lg ${speed === 0 ? 'is-plain' : ''}`}>
              {fmt(live.LINE_SPEED, 2)}
              <span className="ach-unit">m/min</span>
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className="ach-bay">
            <div className="ach-label">Metri pe tambur</div>
            <div className="ach-value lg">
              {grp(live.METER_ACT, 1)}
              <span className="ach-unit">m</span>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col md={12}>
          <div className="ach-bay">
            <div className="ach-label">Contor total — de la montarea contorului</div>
            <div className="ach-value is-plain">
              {grp(live.METER_TOTAL)}
              <span className="ach-unit">m</span>
            </div>
          </div>
        </Col>
      </Row>

      {/* Said plainly rather than left to be inferred from a thin screen. The
          question "why does this line show less?" has an answer, and printing it
          costs one line. */}
      <div className="ach-note">
        Linie contorizată de un Raspberry Pi, fără PLC — cele cinci valori de mai
        sus sunt tot ce publică. Traseele istorice sunt în Machine Tracking.
      </div>
    </div>
  );
};

export default MeterLineHmi;
